var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Tune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9375 8.9375V7.0625H15.9375V3.1875H17.8125V7.0625H20.8125V8.9375H12.9375ZM15.9375 20.8125V11.0625H17.8125V20.8125H15.9375ZM6.1875 20.8125V16.9375H3.1875V15.0625H11.0625V16.9375H8.0625V20.8125H6.1875ZM6.1875 12.9375V3.1875H8.0625V12.9375H6.1875Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTune);
export default __webpack_public_path__ + "static/media/icon-tune.046e74c705efd41b9ded9b3dc35bdba4.svg";
export { ForwardRef as ReactComponent };